export const formatSP = (dateStr, options = {}) => {
  if (!dateStr) return '';
  const defaultOpts = {
    timeZone: 'America/Sao_Paulo',
    hour12: false,
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...options,
  };
  return new Date(dateStr).toLocaleString('pt-BR', defaultOpts);
};
